import { useQuery } from '@tanstack/react-query';
import { getAllVehicles } from '@api/vehicles';

export const useGetVehicles = () => {
  const { data: vehicles = [], isFetching } = useQuery({
    queryFn: () => getAllVehicles(),
    queryKey: ['vehicles'],
  });

  const getVehicleName = (vehicleId: string) => {
    return vehicles.find((vehicle) => vehicle.id === vehicleId)?.registrationNumber;
  };

  const vehiclesOptions = vehicles.map((vehicle) => ({
    label: vehicle.registrationNumber,
    value: vehicle.id,
  }));

  return { vehicles, isFetching, getVehicleName, vehiclesOptions };
};
